import { Directive, TemplateRef } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[buttonToggleGap]'
})
export class ButtonToggleGapDirective {
  constructor(public tpl: TemplateRef<any>) {}
}
